import { FC, FormEventHandler, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import clsx from 'clsx';
import { useSetAtom } from 'jotai';
import { KeyRound, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Logo from '@assets/Logo.svg?react';

import css from './LoginPage.module.css';

import { authService } from 'v2/api/authService';
import { userAtom } from 'v2/atoms/userAtom';
import { AppRoute } from 'v2/routes';
import { handleHttpError } from 'v2/utils';

export const LoginPage: FC = () => {
  const navigate = useNavigate();

  const [key, setKey] = useState('');

  const setUser = useSetAtom(userAtom);

  const { trigger, isMutating } = useSWRMutation('login', authService.login, {
    onSuccess: (data) => {
      setUser(data);
      navigate(AppRoute.ROOT);
    },
    onError: handleHttpError,
  });

  const handleSubmit: FormEventHandler = (e) => {
    e.preventDefault();

    if (key) {
      trigger(key);
    } else {
      toast.error('Empty key... Please fill out the form');
    }
  };

  return (
    <section className={css.loginPage}>
      <span className={css.topLeftDecoration} />
      <span className={css.bottomLeftDecoration} />
      <span className={css.topRightDecoration} />
      <span className={css.bottomRightDecoration} />

      <div className={css.loginFormContainer}>
        <Logo />

        <form className={css.loginForm} onSubmit={handleSubmit}>
          <div className={css.loginFormInputContainer}>
            <KeyRound />

            <input
              className={css.loginFormInput}
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Enter key"
              type="password"
            />
          </div>

          <button className={css.loginPageSubmit} type="submit">
            {isMutating ? (
              <Loader2 className={clsx(css.submitLoader, 'animate-spin')} width={20} height={20} />
            ) : (
              'Log in'
            )}
          </button>
        </form>
      </div>
    </section>
  );
};
